export type PageKey = 'dashboard' | 'record' | 'history' | 'templates' | 'account' | 'admin';

export interface PageInfo {
  key: PageKey;
  path: string;
  requiresAdmin?: boolean;
}

export const pages: PageInfo[] = [
  { key: 'dashboard', path: '/app' },
  { key: 'record', path: '/app/record' },
  { key: 'history', path: '/app/history' },
  { key: 'templates', path: '/app/templates' },
  { key: 'account', path: '/app/account' },
  { key: 'admin', path: '/app/admin', requiresAdmin: true },
];

export const getPageIndex = (path: string, isAdmin: boolean = false): number => {
  const availablePages = isAdmin ? pages : pages.filter(p => !p.requiresAdmin);
  return availablePages.findIndex(p => p.path === path);
};

export const getNextPage = (currentPath: string, isAdmin: boolean = false): string | null => {
  const availablePages = isAdmin ? pages : pages.filter(p => !p.requiresAdmin);
  const currentIndex = getPageIndex(currentPath, isAdmin);
  
  if (currentIndex === -1 || currentIndex === availablePages.length - 1) {
    return null;
  }
  
  return availablePages[currentIndex + 1].path;
};

export const getPreviousPage = (currentPath: string, isAdmin: boolean = false): string | null => {
  const availablePages = isAdmin ? pages : pages.filter(p => !p.requiresAdmin);
  const currentIndex = getPageIndex(currentPath, isAdmin);
  
  if (currentIndex <= 0) {
    return null;
  }
  
  return availablePages[currentIndex - 1].path;
};

export const canSwipeLeft = (currentPath: string, isAdmin: boolean = false): boolean => {
  return getNextPage(currentPath, isAdmin) !== null;
};

export const canSwipeRight = (currentPath: string, isAdmin: boolean = false): boolean => {
  return getPreviousPage(currentPath, isAdmin) !== null;
};
